/** Enum of all available countries */
export enum Country {
  /** Switzerland */
  CH = 'CH',

  /** Germany */
  DE = 'DE',

  /** Austria */
  AT = 'AT',

  /** France */
  FR = 'FR',

  /** Luxembourg */
  LU = 'LU',

  /** United Kingdom (ISO compliant) */
  GB = 'GB',

  /** Croatia */
  HR = 'HR',

  /** Spain */
  ES = 'ES',

  /** Belgium */
  BE = 'BE',

  /** Netherlands */
  NL = 'NL',
}

/** Countries excluded from the self-registration flow (non-EU / unsupported for onboarding) */
const EXCLUDED_REGISTRATION_COUNTRIES: Country[] = [Country.FR, Country.GB, Country.HR]

/** Countries available in the self-registration flow */
export const REGISTRATION_COUNTRIES = Object.values(Country)
  .filter(c => !EXCLUDED_REGISTRATION_COUNTRIES.includes(c))